import { apolloClient } from '@client/api/graphql/client';
import { useInfiniteQuery } from '@tanstack/react-query';
import {
  GetCommunityPostDocument,
  GetCommunityPostQueryVariables,
  GetCommunityPostQuery,
} from '../../../../generated/graphql';
import { communityQueryKeys } from '../constants';
import { getParams } from '@client/new/community/hooks/useCommunityPosts';

const REPLIES_PAGINATION_SIZE = 25;

export const useCommunityComments = (
  communityId: number,
  postId: string,
  lastId?: string,
) => {
  return useInfiniteQuery({
    queryKey: communityQueryKeys.postComments(Number(communityId), postId),
    queryFn: async ({ pageParam = {} }) => {
      const response = await apolloClient.query<
        GetCommunityPostQuery,
        GetCommunityPostQueryVariables
      >({
        query: GetCommunityPostDocument,
        variables: {
          communityId,
          postId,
          lastId: lastId || undefined,
          ...getParams(pageParam),
        },
        fetchPolicy: 'network-only',
      });
      return response.data.post?.replies;
    },
    getNextPageParam: (lastPage) => {
      if (lastPage && lastPage.length < REPLIES_PAGINATION_SIZE) {
        return;
      }
      const lastPostComment =
        lastPage && lastPage?.length !== 0
          ? lastPage[lastPage.length - 1]
          : null;
      if (lastPostComment?.id) {
        return {
          lastId: lastPostComment.id,
          direction: 'olderThan',
        };
      }
    },
    keepPreviousData: true,
    refetchOnMount: true,
    enabled: typeof communityId !== null && typeof postId !== null,
    refetchOnWindowFocus: false,
    refetchInterval: 30000,
  });
};
